<div class="average-growth-score-wrapper">
  <div class="growth-score-checkbox-wrapper">
    <div class="growth-score-checkbox" *ngFor="let item of growthScoreCardCheckbox">
      <growth-report-cel-checkbox-item
        class="checkbox"
        [label]="item.label"
        [checkboxItemAriaLabel]="item.label"
        [identifier]="item.identifier"
        [checked]="item.checked"
        [disabled]="item.disabled"
        (celCheckboxInputChanged)="checkboxClicked($event)"
      ></growth-report-cel-checkbox-item>
    </div>
  </div>
  <div class="growth-score-line-chart-legend-label-wrapper">
    <div
      class="growth-score-line-chart-legend-label"
      *ngFor="let growthScoreCardLabelItem of growthScoreCardLabel"
    >
      <growth-report-cel-icon
        [iconAriaLabel]="growthScoreCardLabelItem.label"
        [src]="getSvgPath(growthScoreCardLabelItem.labelIconKey)"
      ></growth-report-cel-icon>
      <span class="graph-legend-label">{{ growthScoreCardLabelItem.label }}</span>
    </div>
  </div>
</div>
<app-growth-score-graph [growthScoreGraph]="growthScoreGraph"></app-growth-score-graph>
